import { Reducer } from "redux";

import { RoutesAction, RoutesActionTypes, RoutesState } from "./types";

const initialState: RoutesState = {
  count: 0,
  items: [],
  isLoading: false,
};

const reducer: Reducer<RoutesState, RoutesAction> = (state = initialState, action) => {
  switch (action.type) {
    case RoutesActionTypes.TABLE_FETCH_REQUEST:
      return { ...state, isLoading: true };

    case RoutesActionTypes.TABLE_FETCH_ERROR:
      return { ...state, isLoading: false };

    case RoutesActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, items: results };
    }

    default:
      return state;
  }
};

export default reducer;
